import React from "react";
import { Button, Col, Icon, Modal, Row } from "antd";

import stories from "../data/stories";
import { observer } from "mobx-react";

const imgs = {
  kanai: {
    a: require("../imgs/stories/kanai/a.no1.jpg"),
    b: require("../imgs/stories/kanai/b.no1.jpg"),
    c: require("../imgs/stories/kanai/c.no1.jpg"),
    d: require("../imgs/stories/kanai/d.no1.jpg"),
    e: require("../imgs/stories/kanai/e.no1.jpg"),
    f: require("../imgs/stories/kanai/f.no1.jpg"),
    g: require("../imgs/stories/kanai/g.no1.jpg"),
    h: require("../imgs/stories/kanai/h.no1.jpg"),
    i: require("../imgs/stories/kanai/i.no1.jpg"),
    j: require("../imgs/stories/kanai/j.no1.jpg"),
    k: require("../imgs/stories/kanai/k.no1.jpg"),
    l: require("../imgs/stories/kanai/l.no1.jpg"),
    m: require("../imgs/stories/kanai/m.no1.jpg"),
    n: require("../imgs/stories/kanai/n.no1.jpg"),
    o: require("../imgs/stories/kanai/o.no1.jpg"),
    p: require("../imgs/stories/kanai/p.no1.jpg"),
    q: require("../imgs/stories/kanai/q.no1.jpg"),
    r: require("../imgs/stories/kanai/r.no1.jpg"),
    s: require("../imgs/stories/kanai/s.no1.jpg"),
    t: require("../imgs/stories/kanai/t.no1.jpg"),
    u: require("../imgs/stories/kanai/u.no1.jpg"),
    ai2: require("../imgs/stories/kanai/a.no2.jpg"),
    bi2: require("../imgs/stories/kanai/b.no2.jpg"),
    ci2: require("../imgs/stories/kanai/c.no2.jpg"),
    di2: require("../imgs/stories/kanai/d.no2.jpg"),
    d1i2: require("../imgs/stories/kanai/d1.no2.jpg"),
    d2i2: require("../imgs/stories/kanai/d2.no2.jpg"),
    d3i2: require("../imgs/stories/kanai/d3.no2.jpg"),
    d4i2: require("../imgs/stories/kanai/d4.no2.jpg"),
    d5i2: require("../imgs/stories/kanai/d5.no2.jpg"),
    d6i2: require("../imgs/stories/kanai/d6.no2.jpg"),
    d7i2: require("../imgs/stories/kanai/d7.no2.jpg"),
    d8i2: require("../imgs/stories/kanai/d8.no2.jpg"),
    d9i2: require("../imgs/stories/kanai/d9.no2.jpg"),
    d10i2: require("../imgs/stories/kanai/d10.no2.jpg"),
    d11i2: require("../imgs/stories/kanai/d11.no2.jpg"),
    d12i2: require("../imgs/stories/kanai/d12.no2.jpg"),
    d13i2: require("../imgs/stories/kanai/d13.no2.jpg"),
    d14i2: require("../imgs/stories/kanai/d14.no2.jpg"),
    d15i2: require("../imgs/stories/kanai/d15.no2.jpg"),
    d16i2: require("../imgs/stories/kanai/d16.no2.jpg"),
    d17i2: require("../imgs/stories/kanai/d17.no2.jpg"),
    d18i2: require("../imgs/stories/kanai/d18.no2.jpg"),
    d19i2: require("../imgs/stories/kanai/d19.no2.jpg"),
    ei2: require("../imgs/stories/kanai/e.no2.jpg"),
    e1i2: require("../imgs/stories/kanai/e1.no2.jpg"),
    e2i2: require("../imgs/stories/kanai/e2.no2.jpg"),
    e3i2: require("../imgs/stories/kanai/e3.no2.jpg"),
    e4i2: require("../imgs/stories/kanai/e4.no2.jpg"),
    e5i2: require("../imgs/stories/kanai/e5.no2.jpg"),
    e6i2: require("../imgs/stories/kanai/e6.no2.jpg"),
    e7i2: require("../imgs/stories/kanai/e7.no2.jpg"),
    e8i2: require("../imgs/stories/kanai/e8.no2.jpg"),
    e9i2: require("../imgs/stories/kanai/e9.no2.jpg"),
    e10i2: require("../imgs/stories/kanai/e10.no2.jpg"),
    e11i2: require("../imgs/stories/kanai/e11.no2.jpg"),
    e12i2: require("../imgs/stories/kanai/e12.no2.jpg"),
    e13i2: require("../imgs/stories/kanai/e13.no2.jpg"),
    e14i2: require("../imgs/stories/kanai/e14.no2.jpg"),
    e15i2: require("../imgs/stories/kanai/e15.no2.jpg"),
    e16i2: require("../imgs/stories/kanai/e16.no2.jpg"),
    e17i2: require("../imgs/stories/kanai/e17.no2.jpg"),
    e18i2: require("../imgs/stories/kanai/e18.no2.jpg"),
    e19i2: require("../imgs/stories/kanai/e19.no2.jpg"),
    fi2: require("../imgs/stories/kanai/f.no2.jpg"),
    gi2: require("../imgs/stories/kanai/g.no2.jpg"),
    hi2: require("../imgs/stories/kanai/h.no2.jpg"),
    ii2: require("../imgs/stories/kanai/i.no2.jpg"),
    ji2: require("../imgs/stories/kanai/j.no2.jpg"),
    ki2: require("../imgs/stories/kanai/k.no2.jpg"),
    li2: require("../imgs/stories/kanai/l.no2.jpg"),
    mi2: require("../imgs/stories/kanai/m.no2.jpg"),
    ni2: require("../imgs/stories/kanai/n.no2.jpg"),
    oi2: require("../imgs/stories/kanai/o.no2.jpg"),
    pi2: require("../imgs/stories/kanai/p.no2.jpg"),
    qi2: require("../imgs/stories/kanai/q.no2.jpg"),
    ri2: require("../imgs/stories/kanai/r.no2.jpg"),
    si2: require("../imgs/stories/kanai/s.no2.jpg"),
    ti2: require("../imgs/stories/kanai/t.no2.jpg"),
    ui2: require("../imgs/stories/kanai/u.no2.jpg"),
    u1i2: require("../imgs/stories/kanai/u1.no2.jpg"),
    u2i2: require("../imgs/stories/kanai/u2.no2.jpg"),
    u3i2: require("../imgs/stories/kanai/u3.no2.jpg"),
    u4i2: require("../imgs/stories/kanai/u4.no2.jpg"),
    u5i2: require("../imgs/stories/kanai/u5.no2.jpg"),
    u6i2: require("../imgs/stories/kanai/u6.no2.jpg"),
    u7i2: require("../imgs/stories/kanai/u7.no2.jpg"),
    u8i2: require("../imgs/stories/kanai/u8.no2.jpg"),
    u9i2: require("../imgs/stories/kanai/u9.no2.jpg"),
    u10i2: require("../imgs/stories/kanai/u10.no2.jpg"),
    u11i2: require("../imgs/stories/kanai/u11.no2.jpg"),
    u12i2: require("../imgs/stories/kanai/u12.no2.jpg"),
    u13i2: require("../imgs/stories/kanai/u13.no2.jpg"),
    u14i2: require("../imgs/stories/kanai/u14.no2.jpg"),
    u15i2: require("../imgs/stories/kanai/u15.no2.jpg"),
    u16i2: require("../imgs/stories/kanai/u16.no2.jpg"),
    u17i2: require("../imgs/stories/kanai/u17.no2.jpg"),
    u18i2: require("../imgs/stories/kanai/u18.no2.jpg"),
    u19i2: require("../imgs/stories/kanai/u19.no2.jpg")
  },
  nakagawa: {
    a: require("../imgs/stories/nakagawa/a.no1.jpg"),
    b: require("../imgs/stories/nakagawa/b.no1.jpg"),
    c: require("../imgs/stories/nakagawa/c.no1.jpg"),
    d: require("../imgs/stories/nakagawa/d.no1.jpg"),
    e: require("../imgs/stories/nakagawa/e.no1.jpg"),
    f: require("../imgs/stories/nakagawa/f.no1.jpg"),
    g: require("../imgs/stories/nakagawa/g.no1.jpg"),
    h: require("../imgs/stories/nakagawa/h.no1.jpg"),
    i: require("../imgs/stories/nakagawa/i.no1.jpg"),
    j: require("../imgs/stories/nakagawa/j.no1.jpg"),
    k: require("../imgs/stories/nakagawa/k.no1.jpg"),
    l: require("../imgs/stories/nakagawa/l.no1.jpg"),
    m: require("../imgs/stories/nakagawa/m.no1.jpg"),
    n: require("../imgs/stories/nakagawa/n.no1.jpg"),
    o: require("../imgs/stories/nakagawa/o.no1.jpg"),
    p: require("../imgs/stories/nakagawa/p.no1.jpg"),
    q: require("../imgs/stories/nakagawa/q.no1.jpg"),
    r: require("../imgs/stories/nakagawa/r.no1.jpg"),
    s: require("../imgs/stories/nakagawa/s.no1.jpg"),
    t: require("../imgs/stories/nakagawa/t.no1.jpg"),
    u: require("../imgs/stories/nakagawa/u.no1.jpg"),
    ai2: require("../imgs/stories/nakagawa/a.no2.jpg"),
    bi2: require("../imgs/stories/nakagawa/b.no2.jpg"),
    ci2: require("../imgs/stories/nakagawa/c.no2.jpg"),
    di2: require("../imgs/stories/nakagawa/d.no2.jpg"),
    ei2: require("../imgs/stories/nakagawa/e.no2.jpg"),
    e1i2: require("../imgs/stories/nakagawa/e1.no2.jpg"),
    e2i2: require("../imgs/stories/nakagawa/e2.no2.jpg"),
    e3i2: require("../imgs/stories/nakagawa/e3.no2.jpg"),
    e4i2: require("../imgs/stories/nakagawa/e4.no2.jpg"),
    e5i2: require("../imgs/stories/nakagawa/e5.no2.jpg"),
    e6i2: require("../imgs/stories/nakagawa/e6.no2.jpg"),
    e7i2: require("../imgs/stories/nakagawa/e7.no2.jpg"),
    e8i2: require("../imgs/stories/nakagawa/e8.no2.jpg"),
    e9i2: require("../imgs/stories/nakagawa/e9.no2.jpg"),
    e10i2: require("../imgs/stories/nakagawa/e10.no2.jpg"),
    e11i2: require("../imgs/stories/nakagawa/e11.no2.jpg"),
    e12i2: require("../imgs/stories/nakagawa/e12.no2.jpg"),
    e13i2: require("../imgs/stories/nakagawa/e13.no2.jpg"),
    e14i2: require("../imgs/stories/nakagawa/e14.no2.jpg"),
    e15i2: require("../imgs/stories/nakagawa/e15.no2.jpg"),
    e16i2: require("../imgs/stories/nakagawa/e16.no2.jpg"),
    e17i2: require("../imgs/stories/nakagawa/e17.no2.jpg"),
    e18i2: require("../imgs/stories/nakagawa/e18.no2.jpg"),
    e19i2: require("../imgs/stories/nakagawa/e19.no2.jpg"),
    fi2: require("../imgs/stories/nakagawa/f.no2.jpg"),
    gi2: require("../imgs/stories/nakagawa/g.no2.jpg"),
    hi2: require("../imgs/stories/nakagawa/h.no2.jpg"),
    ii2: require("../imgs/stories/nakagawa/i.no2.jpg"),
    ji2: require("../imgs/stories/nakagawa/j.no2.jpg"),
    ki2: require("../imgs/stories/nakagawa/k.no2.jpg"),
    li2: require("../imgs/stories/nakagawa/l.no2.jpg"),
    mi2: require("../imgs/stories/nakagawa/m.no2.jpg"),
    ni2: require("../imgs/stories/nakagawa/n.no2.jpg"),
    oi2: require("../imgs/stories/nakagawa/o.no2.jpg"),
    pi2: require("../imgs/stories/nakagawa/p.no2.jpg"),
    qi2: require("../imgs/stories/nakagawa/q.no2.jpg"),
    ri2: require("../imgs/stories/nakagawa/r.no2.jpg"),
    si2: require("../imgs/stories/nakagawa/s.no2.jpg"),
    ti2: require("../imgs/stories/nakagawa/t.no2.jpg"),
    ui2: require("../imgs/stories/nakagawa/u.no2.jpg"),
    u1i2: require("../imgs/stories/nakagawa/u1.no2.jpg"),
    u2i2: require("../imgs/stories/nakagawa/u2.no2.jpg"),
    u3i2: require("../imgs/stories/nakagawa/u3.no2.jpg"),
    u4i2: require("../imgs/stories/nakagawa/u4.no2.jpg"),
    u5i2: require("../imgs/stories/nakagawa/u5.no2.jpg"),
    u6i2: require("../imgs/stories/nakagawa/u6.no2.jpg"),
    u7i2: require("../imgs/stories/nakagawa/u7.no2.jpg"),
    u8i2: require("../imgs/stories/nakagawa/u8.no2.jpg"),
    u9i2: require("../imgs/stories/nakagawa/u9.no2.jpg"),
    u10i2: require("../imgs/stories/nakagawa/u10.no2.jpg"),
    u11i2: require("../imgs/stories/nakagawa/u11.no2.jpg"),
    u12i2: require("../imgs/stories/nakagawa/u12.no2.jpg"),
    u13i2: require("../imgs/stories/nakagawa/u13.no2.jpg"),
    u14i2: require("../imgs/stories/nakagawa/u14.no2.jpg"),
    u15i2: require("../imgs/stories/nakagawa/u15.no2.jpg"),
    u16i2: require("../imgs/stories/nakagawa/u16.no2.jpg"),
    u17i2: require("../imgs/stories/nakagawa/u17.no2.jpg"),
    u18i2: require("../imgs/stories/nakagawa/u18.no2.jpg"),
    u19i2: require("../imgs/stories/nakagawa/u19.no2.jpg")
  }
};

const adapt = (story, book) => {
  story = story.replace(/◯◯◯/g, book.receiverName);
  story = story.replace(/△△△/g, book.childrenToRender);
  story = story.replace(/◯△◯/g, book.childrenRender);
  story = story.replace(/△◯△/g, book.children + 1);
  story = book.children > 0 ?
    story :
    story.replace(
      /、家族みんなでたわいもないことで/g,
      `、${book.receiverName}と一緒にたわいもないことで`
    );
  story = story.replace(/【あなたの好物】/g, book.likedHomeCooking);
  return story;
};

const getImg = (book, id, is2Page = false) => {
  const a = book.artistName !== "" ? book.artistName : "kanai",
    withTemplate = `${id}${book.childrenTemplate}${is2Page ? 'i2' : ''}`,
    withoutTemplate = `${id}${is2Page ? 'i2' : ''}`;
  return imgs[a][withTemplate] || imgs[a][withoutTemplate];
}

const Story = ({ artistName, book, id }) => (
  <div className="story">
    <div
      style={{
        background: "white",
        display: "inline-block",
        marginBottom: "5px",
        padding: "5px 12px"
      }}
    >{`ストーリー ${id.toUpperCase()}`}</div>
    <div
      className="f-14 lh-24"
      style={{ background: "white", padding: "15px 12px" }}
      dangerouslySetInnerHTML={{ __html: adapt(stories[id], book) }}
    />
    <br />
    <div style={{ overflowX: "scroll" }}>
      <div style={{ width: "180%" }}>
        <img
          style={{ float: "left" }}
          src={getImg(book, id)}
        />
        <img
          style={{ float: "right" }}
          src={getImg(book, id, true)}
        />
      </div>
    </div>
  </div>
);

class StoryList extends React.Component {
  constructor() {
    super();
    this.state = { visible: false };
  }

  handleCancel = e => {
    this.setState({ visible: false });
  };

  handleNext = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) + 1] });
  };

  handlePrevious = () => {
    const l = this.props.list;
    this.setState({ current: l[l.indexOf(this.state.current) - 1] });
  };

  handleSelect = e => {
    this.props.onSelect(this.state.current);
    this.setState({ visible: false });
  };

  handleShowModal = () => {
    this.setState({ visible: true });
  };

  componentWillMount() {
    this.setState({ current: this.props.selected || this.props.list[0] });
  }

  componentWillReceiveProps(props) {
    this.setState({ current: props.selected || props.list[0] });
  }

  render() {
    const current = this.state.current,
      { artistName, list, storyNumber } = this.props,
      prev = list.indexOf(current) === 0,
      next = list.indexOf(current) === list.length - 1;
    return (
      <div>
        <div className="story-list link" onClick={this.handleShowModal}>
          <Icon
            type={this.props.selected ? "check-circle" : "edit"}
            style={{ float: "left", marginRight: "5px" }}
            theme="outlined"
          />
          {`ストーリー${storyNumber} `}
          <span className="f-12">{"（見開き2ページ分）"}</span>
          <Icon type="right" />
        </div>
        <Modal
          onCancel={this.handleCancel}
          bodyStyle={{ padding: "10px 0px", background: "#F6F4F9" }}
          //style={{ top: 5 }}
          visible={this.state.visible}
          footer={null}
        >
          <Row className="story-list">
            <Col span={1} />
            <Col span={22}>
              <br />
              <br />
              <Story
                artistName={artistName}
                book={this.props.book}
                id={current}
              />
              {"※顔画像はサンプルになります"}
              <br />
              <br />
              <Row className="story-list" type="flex" justify="space-around">
                <Col span={4} onClick={prev ? null : this.handlePrevious}>
                  <Icon
                    style={{
                      color: prev ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "left",
                      marginTop: "9px"
                    }}
                    type="left"
                  />
                  <span style={{ top: "11px", position: "relative" }}>
                    前へ
                  </span>
                </Col>
                <Col span={16} style={{ width: "170px" }}>
                  <Button
                    disabled={
                      this.props.disabled.indexOf(this.state.current) !== -1
                    }
                    key="submit"
                    type="primary"
                    onClick={this.handleSelect}
                    style={{
                      width: "170px",
                      padding: "10px",
                      height: "auto"
                    }}
                  >
                    {this.props.disabled.indexOf(this.state.current) !== -1
                      ? "選択済み"
                      : "このストーリーを選ぶ"}
                  </Button>
                </Col>
                <Col span={4} onClick={next ? null : this.handleNext}>
                  <span style={{ top: "11px", position: "relative" }}>
                    次へ
                  </span>
                  <Icon
                    style={{
                      color: next ? "lightgrey" : "#674397",
                      fontSize: 25,
                      float: "right",
                      marginTop: "9px"
                    }}
                    type="right"
                  />
                </Col>
              </Row>
              <br />
            </Col>
            <Col span={1} />
          </Row>
        </Modal>
      </div>
    );
  }
}

export default observer(StoryList);



// WEBPACK FOOTER //
// ./src/components/Storylist.js